import emailjs from '@emailjs/browser';

const emailServiceId = process.env.REACT_APP_EMAIL_SERVICE_ID;
const emailTemplateId = process.env.REACT_APP_EMAIL_TEMPLATE_ID;
const emailPubKey = process.env.REACT_APP_EMAIL_PUBLIC_KEY;


function submit(data) {
  const templateParams = {
      to_name: 'George',
      from_name: data.name,
      message: `Interested in: ${data.selectedOption} \n${data.message}`
  };

  return emailjs.send(emailServiceId, emailTemplateId, templateParams, emailPubKey)
    .then(function(response) {
      return "Thank you for contacting us!"
    }, function(error) {
      return new Error(
        error
      )
    })

}

const contact = { submit };

export default contact;
